export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEMS = "DELETE_ITEMS";
export const INCREMENT_ITEM = "INCREMENT_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const SET_CURRENCY = "SET_CURRENCY";
export const SET_SELECTED = "SET_SELECTED";
export const SHOW_SHOPPING_CART = "SHOW_SHOPPING_CART";
export const SHOW_PRODUCT_OPTIONS_MODAL = "SHOW_PRODUCT_OPTIONS_MODAL";
export const SUBSTRACT_ITEM = "SUBSTRACT_ITEM";
